import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import de from './locales/de.json'
import ar from './locales/ar.json'

const saved = localStorage.getItem('ilia.locale')
const initial = saved === 'ar' || saved === 'de' ? saved : 'de'

void i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    ar: { translation: ar },
  },
  lng: initial,
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
})

export function applyDocumentDirection(locale: string) {
  const dir = locale === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.lang = locale
  document.documentElement.dir = dir
}

applyDocumentDirection(initial)

export default i18n
